import { render, staticRenderFns } from "./meetingRoom.vue?vue&type=template&id=7b64fab2&scoped=true"
import script from "./meetingRoom.vue?vue&type=script&lang=js"
export * from "./meetingRoom.vue?vue&type=script&lang=js"
import style0 from "./meetingRoom.vue?vue&type=style&index=0&id=7b64fab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b64fab2",
  null
  
)

export default component.exports